module.exports = __webpack_public_path__ + "static/model-off-image-2-474bb81d98cd5a1820626e7a177d0c7d.jpg";